export default {

    namespaced: true,

    // Usage:
    // store.state.activePatient.id
    // store.state.activePatient.treatmentsLoaded
    state: {
        drawer: false,
        drawerRight: false,
        dashboardScrollPosition: 0,
        dashboardSettings: false,
    },
};
